import { createSlice } from "@reduxjs/toolkit";

const groceryItems = JSON.parse(localStorage.getItem("grocery-bud")) || [];
const initialState = {
  groceryItems,
  editDetails: {},
  reply: { type: null, message: "" },
  isEditing: false,
};
const itemsSlice = createSlice({
  name: "items",
  initialState,
  reducers: {
    onSaveGroceryItem: (state, action) => {
      state.groceryItems = [action.payload, ...state.groceryItems];
    },
    onSaveGroceryItems: (state, action) => {
      state.isEditing = false;
      state.editDetails = {};
      state.groceryItems = action.payload;
    },
    onDeleteGroceryItem: (state, action) => {
      state.groceryItems = action.payload;
    },
    onEditing: (state, action) => {
      state.isEditing = action.payload.isEditing;
      state.editDetails = action.payload.editDetails;
    },
    onChangeReply: (state, action) => {
      state.reply = action.payload;
    },
  },
});

export const itemsActions = itemsSlice.actions;

export default itemsSlice.reducer;
